'use strict';

export default class StablishmentGallery {
  constructor(options) {
    console.log('StablishmentGallery module');

    const defaults = {
        sliderClass: '.stablishmentGallery__list',
        thumbClass: '.stablishmentGallery__thumbs',
        iframes: '.embed-player',
        slidesToShow: 4
    };

    this.options = Object.assign({}, defaults, options);

    //exposed methods
    this._startSlider();
  }

  _startSlider () {
    let context = this;

    // Initialize
    $(this.options.sliderClass).on("init", function(slick){
      slick = $(slick.currentTarget);
      setTimeout(function(){
        context._playPauseVideo(slick,"play");
      }, 1000);
    }).bind(context);

    $(this.options.sliderClass).on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      context._playPauseVideo(slick,"pause");
    }).bind(context);

    $(this.options.sliderClass).on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      context._playPauseVideo(slick,"play");
    }).bind(context);

    $(this.options.sliderClass).slick({
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      slidesToScroll: 1,
      mobileFirst: true,
      fade:true,
      asNavFor: this.options.thumbClass
    });

    $(this.options.thumbClass).slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true,
      arrows: true,
      asNavFor: this.options.sliderClass,

      responsive: [
      {
        mobileFirst: false,
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]
    });
  }

  _postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  _playPauseVideo(slick, control){
    let currentSlide, player;

    currentSlide = slick.find(".slick-current");
    player = currentSlide.find("iframe").get(0);

    switch (control) {
      case "play":
        this._postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        this._postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        this._postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  }
}
